import React, { useState } from "react";
import phone from "./phoneIcon.svg";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import tick from "../../images/tick.svg";

const ContactSupport = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const handleContactSupport = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("message", message);
    const options = {
      headers: { Authorization: token },
      url: `${process.env.REACT_APP_URL}/lender/contact_support`,
      data: formData,
      method: "POST",
    };
    const res = await axios(options);
    if (res.data.message === "Email Sent Successfully") {
      setEmailSent(true);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Montserrat",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <ArrowBack
        style={{
          color: "#1F1F1F",
          cursor: "pointer",
          position: "absolute",
          top: 40,
          left: 60,
          fontSize: "50px",
        }}
        fontSize="large"
        onClick={() => navigate(-1)}
      />
      {emailSent ? (
        <>
          <div
            style={{
              background: "#fff",
              width: "450px",
              height: "350px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-evenly",
              borderRadius: "5px",
              boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.2)",
            }}
          >
            <img src={tick} alt="tick" width={200} />
            <p style={{ fontSize: "30px", fontWeight: "700" }}>Thank you</p>
            <p style={{ fontSize: "17px" }}>
              Your message has been received and we <br /> will be contacting
              you shortly.
            </p>
            <button
              style={{
                background: "#a0ff77",
                border: "none",
                fontWeight: "500",
                fontSize: "18px",
                padding: "10px 50px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              OK
            </button>
          </div>
        </>
      ) : (
        <>
          <div style={{ textAlign: "center", marginLeft: "10px" }}>
            <h1
              style={{ color: "#00394D", fontSize: "40px", fontWeight: "700" }}
            >
              Need help?
            </h1>
            <p
              style={{
                color: "#1F1F1F",
                fontSize: "16px",
                fontWeight: 500,
                marginTop: "10px",
              }}
            >
              Get in touch with our team.
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "400px",
              width: "80%",
              textAlign: "right",
            }}
          >
            <div style={{ display: "flex" }}>
              <form
                style={{ width: "50%", padding: "0px 20px" }}
                onSubmit={handleContactSupport}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p
                      style={{
                        color: "#1F1F1F",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Email
                    </p>
                    <input
                      type="email"
                      style={{
                        border: "none",
                        outline: "none",
                        background: "#00394D0D",
                        padding: "10px",
                        marginBottom: "10px",
                        width: "345px",
                        color: "#00394D",
                        fontSize: "15px",
                        fontWeight: "500",
                        fontFamily: "Montserrat",
                      }}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        color: "#1F1F1F",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Message
                    </p>
                    <div>
                      <input
                        type="text"
                        style={{
                          border: "none",
                          outline: "none",
                          background: "#00394D0D",
                          marginBottom: "10px",
                          padding: "10px",
                          width: "345px",
                          color: "#00394D",
                          fontSize: "15px",
                          fontWeight: "500",
                          fontFamily: "Montserrat",
                        }}
                        placeholder="Subject (optional)"
                        onChange={(e) => setSubject(e.target.value)}
                      />
                      <textarea
                        type="text"
                        style={{
                          border: "none",
                          outline: "none",
                          background: "#00394D0D",
                          padding: "10px",
                          minWidth: "345px",
                          maxWidth: "345px",
                          minHeight: "100px",
                          maxHeight: "240px",
                          color: "#00394D",
                          fontSize: "15px",
                          fontWeight: "500",
                          fontFamily: "Montserrat",
                        }}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  style={{
                    borderRadius: "100px",
                    background: "#A0FF77",
                    padding: "5px 15px",
                    textAlign: "right",
                    border: "none",
                    color: "#00394D",
                    marginTop: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    fontFamily: "Montserrat",
                    cursor: "pointer",
                  }}
                >
                  Submit
                </button>
              </form>
              {/* or */}
              <div
                style={{
                  width: "5%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  marginLeft: "10px",
                }}
              >
                <div
                  style={{
                    borderRight: "2px solid #1F1F1F",
                    height: "50%",
                  }}
                ></div>
                <p
                  style={{
                    color: "#1F1F1F",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  OR
                </p>
                <div
                  style={{
                    borderRight: "2px solid #1F1F1F",
                    height: "50%",
                  }}
                ></div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  height: "200px",
                  width: "430px",
                  textAlign: "right",
                  alignItems: "center",
                  width: "50%",
                }}
              >
                <img src={phone} alt="phone" width={50} height={50} />
                <p
                  style={{
                    color: "#1F1F1F",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Talk to us
                </p>
                <p
                  style={{
                    color: "#1F1F1F",
                    fontSize: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                  }}
                >
                  Have an urgent matter? Just pick up the phone
                  <br /> to chat with a member of our team
                </p>
                <p
                  style={{
                    color: "#0C74D4",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  +91 8148121424
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactSupport;
